<template>
  <router-view/>
  <!-- 全域 AI 助手 -->
  <GlobalAIAssistant v-if="showGlobalAI" />
</template>

<script>
import GlobalAIAssistant from '@/components/GlobalAIAssistant.vue';

export default {
  name: 'App',
  components: {
    GlobalAIAssistant
  },
  computed: {
    showGlobalAI() {
      // AI助手只在管理員後台顯示 (使用者前端不需要)
      const isAdminRoute = this.$route && this.$route.path.startsWith('/admin');
      const isAuthenticated = this.$store.state.auth.isLogin;
      const shouldShow = isAuthenticated && isAdminRoute;
      console.log('showGlobalAI:', shouldShow, 'isAdmin:', isAdminRoute, 'isAuth:', isAuthenticated, 'route:', this.$route?.path);
      return shouldShow;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
